import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthGate } from "@/components/AuthGate";
import Overview from "@/pages/Overview";
import Accounts from "@/pages/Accounts";
import Channels from "@/pages/Channels";
import ChannelScanner from "@/pages/ChannelScanner";
import Rules from "@/pages/Rules";
import Branding from "@/pages/Branding";
import Sandbox from "@/pages/Sandbox";
import Jobs from "@/pages/Jobs";
import Vault from "@/pages/Vault";
import Queue from "@/pages/Queue";
import Notifications from "@/pages/Notifications";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App dark">
      <AuthGate>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Overview />} />
              <Route path="/accounts" element={<Accounts />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/channel-scanner" element={<ChannelScanner />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/branding" element={<Branding />} />
              <Route path="/sandbox" element={<Sandbox />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/queue" element={<Queue />} />
              <Route path="/notifications" element={<Notifications />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthGate>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
